import React from 'react';
import Button from 'react-bootstrap/Button';
import { buildHierarchy, getAllImages } from "../../util";
import "./styles.css";
const AutoQAButton = ({
  panels,
  setReport
}) => {
  return /*#__PURE__*/React.createElement(Button, {
    className: "QA-button",
    onClick: () => {
      if (panels) {
        let panelComponents = [];
        panels.forEach(panel => {
          panelComponents.push(buildHierarchy(panel.children, getAllImages));
        });
        let errors = [];
        for (let i = 0; i < panelComponents.length; ++i) {
          Object.entries(panelComponents[i]).map(v => {
            if (v[1].props.alt === "") {
              errors.push(`Panel ${i + 1}, figure is missing alt text.`);
            }
          });
        }
        setReport(errors);
      }
    }
  }, "QA");
};
export default AutoQAButton;